import type { AgentAttribution } from "../api/e2e";

const CHANNEL_LABELS: Record<AgentAttribution["channel"], string> = {
  browser: "browser",
  cli: "CLI",
  mcp: "MCP",
  api: "API",
};

export default function AgentAttributionLabel({
  attribution,
  empty = "—",
  showChannel = true,
}: {
  attribution: AgentAttribution | null;
  empty?: string;
  showChannel?: boolean;
}) {
  if (!attribution) return <span>{empty}</span>;
  const identity = attribution.display_name || attribution.email;
  if (!showChannel) {
    if (!identity) return <span>{empty}</span>;
    return (
      <span className="agent-attribution">
        <strong>{identity}</strong>
      </span>
    );
  }
  const name = identity || "Workspace user";
  const via = attribution.credential_name
    ? `${attribution.credential_name} · ${CHANNEL_LABELS[attribution.channel]}`
    : CHANNEL_LABELS[attribution.channel];
  return (
    <span className="agent-attribution">
      <strong>{name}</strong>
      <small>via {via}</small>
    </span>
  );
}
